import { createBaseStore } from "@/zustand/create-store";
import { STORAGE_KEYS } from "@/zustand/storage-keys";
import { Auth } from "@/zustand/auth/auth-types";

const initialState: Auth = {
  token: null,
  user: null,
  accessToken: "",
  refreshToken: "",
  isRefreshState: false,
};

const customActions = (set: (state: Partial<Auth>) => void) => ({
  login: (token: string, user: Auth["user"]) => {
    set({ token, user });
  },
  logout: () => {
    set({ token: null, user: null });
  },
});

export const useAuthStore = createBaseStore<Auth>(
  STORAGE_KEYS.AUTH_STORAGE,
  initialState,
  customActions,
);
